"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _marginHelper = require("../../../../helpers/marginHelper");
var _marginSelectors = require("../../../../redux/margin/selectors/marginSelectors");
var _modalActions = require("../../../../redux/actions/modalActions");
var _selectors = require("../../../../redux/margin/selectors");
var _positionSelectors = require("../../../../redux/selectors/positionSelectors");
var _productsSelectors = require("../../../../redux/selectors/productsSelectors");
var _MarginTradingComponent = _interopRequireDefault(require("./MarginTradingComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _marginKVPInfoSelecto = (0, _marginSelectors.marginKVPInfoSelector)(state),
    marginVerificationLevels = _marginKVPInfoSelecto.marginVerificationLevels,
    minDepositValue = _marginKVPInfoSelecto.minDepositValue;
  var spotAccountInfo = (0, _selectors.mainAccountSelector)(state);
  var parsedMarginVerificationLevels = (0, _marginHelper.parseMarginVerificationLevels)(marginVerificationLevels);
  var spotAccountVerificationLevel = (spotAccountInfo === null || spotAccountInfo === void 0 ? void 0 : spotAccountInfo.VerificationLevel) || 0;
  var isSpotAccountFrozen = spotAccountInfo === null || spotAccountInfo === void 0 ? void 0 : spotAccountInfo.Frozen;
  var isVLCheckPassed = parsedMarginVerificationLevels.includes(spotAccountVerificationLevel);
  var mainAccountTotalValue = (0, _positionSelectors.mainAccountPositionsTotalAmountSelector)(state);
  var baseAssetSymbol = (0, _productsSelectors.baseNotionalProductSymbolSelector)(state);
  var isSpotAccountBalanceValidationPassed = mainAccountTotalValue >= minDepositValue;
  var isAllChecksPassed = isVLCheckPassed && !isSpotAccountFrozen && isSpotAccountBalanceValidationPassed;
  var isDoubleWarning = (isSpotAccountFrozen || !isVLCheckPassed) && !isSpotAccountBalanceValidationPassed;
  return {
    marginEnabled: (0, _marginSelectors.marginBorrowerEnabledSelector)(state),
    isSpotAccountFrozen: isSpotAccountFrozen,
    minDepositValue: minDepositValue,
    baseAssetSymbol: baseAssetSymbol,
    isVLCheckPassed: isVLCheckPassed,
    isSpotAccountBalanceValidationPassed: isSpotAccountBalanceValidationPassed,
    isAllChecksPassed: isAllChecksPassed,
    isDoubleWarning: isDoubleWarning
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  openEnableMarginTradingModal: function openEnableMarginTradingModal(isReadOnly) {
    return (0, _modalActions.openModal)(_modalActions.MODAL_TYPES.MARGIN_TRADING, {
      isReadOnly: isReadOnly
    });
  }
})(_MarginTradingComponent["default"]);